module.exports = __webpack_public_path__ + "static/media/Casino.96cc93da.svg";